module.exports = __webpack_public_path__ + "2218b43abe209fec3ab17cc4c6d3c1e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-shapes/images/princess@2x.png
// module id = 310
// module chunks = 0